/**
 * Token utilities
 */

import {Token, TokenType} from "../models/editor.types";

export function normalizeRange(from: number, to: number): { from: number; to: number } {
  return from <= to ? {from, to} : {from: to, to: from};
}

export function overlaps(a: { from: number; to: number }, b: { from: number; to: number }): boolean {
  return a.from < b.to && b.from < a.to;
}

/**
 * Overrides tokens within [from,to) with a new token.
 *
 * Removes any tokens that overlap the selection range, then inserts the new token.
 */
export function overrideTokensInRange(
  tokens: readonly Token[],
  range: { from: number; to: number },
  type: TokenType
): Token[] {
  const {from, to} = normalizeRange(range.from, range.to);
  if (to <= from) return [...tokens];

  const next = tokens.filter((t) => !overlaps({from: t.from, to: t.to}, {from, to}));
  next.push({from, to, type});
  return next;
}

/**
 * Removes any tokens that overlap [from,to).
 */
export function clearTokensInRange(tokens: readonly Token[], range: { from: number; to: number }): Token[] {
  const {from, to} = normalizeRange(range.from, range.to);
  if (to <= from) return [...tokens];
  return tokens.filter((t) => !overlaps({from: t.from, to: t.to}, {from, to}));
}
